
      import API from "!../../../../../../NocturnalStudio/website-geographical-society/website/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../../NocturnalStudio/website-geographical-society/website/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../../../NocturnalStudio/website-geographical-society/website/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../../../NocturnalStudio/website-geographical-society/website/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../../NocturnalStudio/website-geographical-society/website/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../../NocturnalStudio/website-geographical-society/website/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../../NocturnalStudio/website-geographical-society/website/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../../NocturnalStudio/website-geographical-society/website/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./Overlay.scss";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../../NocturnalStudio/website-geographical-society/website/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../../NocturnalStudio/website-geographical-society/website/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./Overlay.scss";
       export default content && content.locals ? content.locals : undefined;
